import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    getDateFormat
} from '../../../../../../../Apis/functions';
import { IconScheduleTable } from '../../../../../../../components/buttons/IconButtons';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Scheduled shift of a breakdown entry, rendered as a start / end pair.
 * Both bounds are datetimes because overnight shifts end on a different day.
 *
 * @param {Date|string|number} startDate - Scheduled start of the shift.
 * @param {Date|string|number} endDate - Scheduled end of the shift.
 */
const ScheduledShiftCell = ({ startDate, endDate }) => {
    const { t } = useTranslation();

    if (!startDate && !endDate) return EMPTY_VALUES.DEFAULT;

    return (
        <>
            <div className='d-flex align-items-center'>
                <div><IconScheduleTable className='mr-8px mb-1 icon-color-general-950' /></div>
                {t('from')}: {getDateFormat(startDate, null, DATE_TIME_FORMAT_NAME_MODEL.dateTimeWithSeconds)}
            </div>
            <div className='d-flex align-items-center'>
                <div><IconScheduleTable className='mr-8px mb-1 icon-color-general-950' /></div>
                {t('to')}: {getDateFormat(endDate, null, DATE_TIME_FORMAT_NAME_MODEL.dateTimeWithSeconds)}
            </div>
        </>
    );
};

export default ScheduledShiftCell;
